<div [ngClass]="{'isProfile': isProfile}" class="preloader-container w-100 d-flex flex-wrap">
  <section *ngFor="let number of [0,1,2,3,4,5]">
    <!-- MISE EN LIGNE -->
    <h3 class="placeholder-glow text-center minitext_3">
      <span class="placeholder col-7"></span>
    </h3>

    <div class="border-0 overflow-hidden mt-2 d-flex flex-column gap-16">
      <!--    IMG    -->
      <div class="placeholder-glow">
        <div class="img-fluid placeholder w-100 br-16"></div>
      </div>
      <!--    NOM    -->
      <div class="d-flex flex-column justify-content-between">
        <h3 class="placeholder-glow text_4 pb-2">
          <span class="placeholder col-6"></span>
        </h3>
        <!--     DISPO/RESA     -->
        <div class="pb-2">
          <p class="placeholder-glow">
            <span class="placeholder col-10"></span>
          </p>
          <p class="placeholder-glow">
            <span class="placeholder col-8"></span>
          </p>
        </div>
        <!-- PRIX -->
        <div class="placeholder-glow">
          <span class="placeholder px-4 py-3"></span>
        </div>
      </div>
    </div>
  </section>

</div>
